import Vue from 'vue';

// vue-infinite-scroll
import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);
